<template>
    <div>
        <fusioncharts
            type="scrollline2d"
            :width="width"
            :height="height"
            :dataSource="dataSource">
        </fusioncharts>
    </div>
</template>

<script>
    export default {
        props: {
            categories: {
                type: [Array, Object],
                required: true,
            },
            data: {
                type: [Array, Object],
                required: true,
            },
            caption: {
                type: String,
                default: ""
            },
            bgColor: {
                type: String,
                default: "#edf2f7"
            },
            width: {
                type: [Number, String],
                default: "100%"
            },
            height: {
                type: [Number, String],
                default: 270
            }
        },

        computed: {
            dataSource() {
                return {
                    chart: {
                        bgColor: this.bgColor,
                        baseFont: '"-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Helvetica Neue", "Arial", "Noto Sans", "sans-serif"',
                        baseFontSize: 15,
                        caption: this.caption,
                        numVisiblePlot: "4",
                        valueFontSize: 16,
                        theme: "fusion"
                    },
                    categories: [
                        {
                          category: this.categories
                        }
                    ],
                    dataset: [
                        {
                          data: this.data
                        }
                    ]
                }
            }
        }
    }
</script>